import { render, staticRenderFns } from "./StudentAttestation.vue?vue&type=template&id=e20a832c"
import script from "./StudentAttestation.vue?vue&type=script&lang=js"
export * from "./StudentAttestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports